import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';
import { ValuationApproachExclusionReason } from './valuationApproachExclusionReason';

export class CostApproachDetail {
    constructor(doc)
    {
		this.label = null;
		this.costAnalysisCommentDescription = null;
		this.costAnalysisType = null;
		this.costMethodType = null;
		this.costMethodTypeOtherDescription = null;
		this.depreciatedCostDwellingsTotalAmount = null;
		this.depreciatedCostOutbuildingsTotalAmount = null;
		this.depreciationMethodType = null;
		this.depreciationMethodTypeOtherDescription = null;
		this.siteEstimatedValueAmount = null;
		this.siteEstimatedValueCommentDescription = null;
		this.siteOtherImprovementsAsIsAmount = null;
		this.siteValuationMethodType = null;
		this.siteValuationMethodTypeOtherDescription = null;
		this.valueIndicatedByCostApproachAmount = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.costAnalysisCommentDescription = x.getStringElement(doc, "./ns:CostAnalysisCommentDescription");
		this.costAnalysisType = x.getStringElement(doc, "./ns:CostAnalysisType");
		this.costMethodType = x.getStringElement(doc, "./ns:CostMethodType");
		this.costMethodTypeOtherDescription = x.getStringElement(doc, "./ns:CostMethodTypeOtherDescription");
		this.depreciatedCostDwellingsTotalAmount  = x.getMISMOAmountElement(doc, "./ns:DepreciatedCostDwellingsTotalAmount");
		this.depreciatedCostOutbuildingsTotalAmount  = x.getMISMOAmountElement(doc, "./ns:DepreciatedCostOutbuildingsTotalAmount");
		this.depreciationMethodType = x.getStringElement(doc, "./ns:DepreciationMethodType");
		this.depreciationMethodTypeOtherDescription = x.getStringElement(doc, "./ns:DepreciationMethodTypeOtherDescription");
		this.siteEstimatedValueAmount  = x.getMISMOAmountElement(doc, "./ns:SiteEstimatedValueAmount");
		this.siteEstimatedValueCommentDescription = x.getStringElement(doc, "./ns:SiteEstimatedValueCommentDescription");
		this.siteOtherImprovementsAsIsAmount  = x.getMISMOAmountElement(doc, "./ns:SiteOtherImprovementsAsIsAmount");
		this.siteValuationMethodType = x.getStringElement(doc, "./ns:SiteValuationMethodType");
		this.siteValuationMethodTypeOtherDescription = x.getStringElement(doc, "./ns:SiteValuationMethodTypeOtherDescription");
		this.valueIndicatedByCostApproachAmount  = x.getMISMOAmountElement(doc, "./ns:ValueIndicatedByCostApproachAmount");
   }
}

export class ImprovementCostDetail {
    constructor(doc)
    {
		this.label = null;
		this.manufacturedHomeInstallationCostAmount = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.manufacturedHomeInstallationCostAmount  = x.getMISMOAmountElement(doc, "./ns:ManufacturedHomeInstallationCostAmount");
   }
}

export class ReplacementReproductionCost {
    constructor(doc)
    {
		this.label = null;
		this.pricePerAreaAmount = null;
		this.replacementOrReproductionCostAmount = null;
		this.replacementOrReproductionCostAreaMeasure = null;
		this.replacementOrReproductionCostAreaType = null;
		this.replacementOrReproductionCostAreaTypeOtherDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.pricePerAreaAmount  = x.getMISMOAmountElement(doc, "./ns:PricePerAreaAmount");
		this.replacementOrReproductionCostAmount  = x.getMISMOAmountElement(doc, "./ns:ReplacementOrReproductionCostAmount");
		this.replacementOrReproductionCostAreaMeasure = x.getMISMOMeasureElement(doc, "./ns:ReplacementOrReproductionCostAreaMeasure");
		this.replacementOrReproductionCostAreaType = x.getStringElement(doc, "./ns:ReplacementOrReproductionCostAreaType");
		this.replacementOrReproductionCostAreaTypeOtherDescription = x.getStringElement(doc, "./ns:ReplacementOrReproductionCostAreaTypeOtherDescription");
   }

	 GetCostAreaType() {
		return h.descriptionOrOther(this.replacementOrReproductionCostAreaType, this.replacementOrReproductionCostAreaTypeOtherDescription);
	 }
}

export class ImprovementCost {
    constructor(doc)
    {
		this.label = null;
		this.improvementCostDetail = null;
		this.replacementReproductionCosts = [];
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:IMPROVEMENT_COST_DETAIL");
		if (node !== null)
				this.improvementCostDetail = new ImprovementCostDetail(node);
		nodes = x.selectNodes(doc, "./ns:REPLACEMENT_REPRODUCTION_COSTS/ns:REPLACEMENT_REPRODUCTION_COST");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.replacementReproductionCosts.push(new ReplacementReproductionCost(xn));
			});
		}
   }
}

export class ImprovementDepreciatedValueSummary {
    constructor(doc)
    {
		this.label = null;
		this.improvementEstimatedTotalCostAmount = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.improvementEstimatedTotalCostAmount  = x.getMISMOAmountElement(doc, "./ns:ImprovementEstimatedTotalCostAmount");
   }
}

export class ImprovementDepreciation {
    constructor(doc)
    {
		this.label = null;
		this.depreciationExternalAmount = null;
		this.depreciationExternalPercent = null;
		this.depreciationFunctionalAmount = null;
		this.depreciationFunctionalPercent = null;
		this.depreciationPhysicalAmount = null;
		this.depreciationPhysicalPercent = null;
		this.depreciationTotalAmount = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.depreciationExternalAmount  = x.getMISMOAmountElement(doc, "./ns:DepreciationExternalAmount");
		this.depreciationExternalPercent = x.getStringElement(doc, "./ns:DepreciationExternalPercent");
		this.depreciationFunctionalAmount  = x.getMISMOAmountElement(doc, "./ns:DepreciationFunctionalAmount");
		this.depreciationFunctionalPercent = x.getStringElement(doc, "./ns:DepreciationFunctionalPercent");
		this.depreciationPhysicalAmount  = x.getMISMOAmountElement(doc, "./ns:DepreciationPhysicalAmount");
		this.depreciationPhysicalPercent = x.getStringElement(doc, "./ns:DepreciationPhysicalPercent");
		this.depreciationTotalAmount  = x.getMISMOAmountElement(doc, "./ns:DepreciationTotalAmount");
   }
}

export class ImprovementCostAndDepreciatedValue {
    constructor(doc)
    {
		this.label = null;
		this.improvementCost = null;
		this.improvementDepreciatedValueSummary = null;
		this.improvementDepreciation = null;
		var node;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:IMPROVEMENT_COST");
		if (node !== null)
				this.improvementCost = new ImprovementCost(node);
		node = x.selectSingleNode(doc, "./ns:IMPROVEMENT_DEPRECIATED_VALUE_SUMMARY");
		if (node !== null)
				this.improvementDepreciatedValueSummary = new ImprovementDepreciatedValueSummary(node);
		node = x.selectSingleNode(doc, "./ns:IMPROVEMENT_DEPRECIATION");
		if (node !== null)
				this.improvementDepreciation = new ImprovementDepreciation(node);
   }

	GetReplacementCosts() {
		let list = [];
		for (let rrc of this.improvementCost.replacementReproductionCosts)
			list.push(rrc);
		return list;
	}

}

export class SiteImprovementsAsIsCost {
    constructor(doc)
    {
		this.label = null;
		this.siteImprovementAsIsCostAmount = null;
		this.siteImprovementDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.siteImprovementAsIsCostAmount  = x.getMISMOAmountElement(doc, "./ns:SiteImprovementAsIsCostAmount");
		this.siteImprovementDescription = x.getStringElement(doc, "./ns:SiteImprovementDescription");
   }
}

export class CostApproach {
    constructor(doc)
    {
		this.label = null;
		this.costApproachDetail = null;
		this.improvementCostAndDepreciatedValues = [];
		this.siteImprovementsAsIsCosts = [];
		this.valuationApproachExclusionReasons = [];
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:COST_APPROACH_DETAIL");
		if (node !== null)
				this.costApproachDetail = new CostApproachDetail(node);
		nodes = x.selectNodes(doc, "./ns:IMPROVEMENT_COST_AND_DEPRECIATED_VALUES/ns:IMPROVEMENT_COST_AND_DEPRECIATED_VALUE");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.improvementCostAndDepreciatedValues.push(new ImprovementCostAndDepreciatedValue(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:SITE_IMPROVEMENTS_AS_IS_COSTS/ns:SITE_IMPROVEMENTS_AS_IS_COST");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.siteImprovementsAsIsCosts.push(new SiteImprovementsAsIsCost(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:VALUATION_APPROACH_EXCLUSION_REASONS/ns:VALUATION_APPROACH_EXCLUSION_REASON");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.valuationApproachExclusionReasons.push(new ValuationApproachExclusionReason(xn));
			});
		}
   }

	GetIndicatedValue() {
		if (!this.costApproachDetail)
			return undefined;
		var value = this.costApproachDetail.depreciatedCostDwellingsTotalAmount ?? 0;
		value += this.costApproachDetail.depreciatedCostOutbuildingsTotalAmount ?? 0;
		value += this.costApproachDetail.siteOtherImprovementsAsIsAmount ?? 0;
		value += this.costApproachDetail.siteEstimatedValueAmount ?? 0;

		return value;
	}

	GetImprovementCostAndDepreciatedValue(label) {
		for (var ic of this.improvementCostAndDepreciatedValues)
			if (ic.label === label)
				return ic;

		return null;
	}

	GetAsIsTotal() {
		var total = 0;
		for (var cost of this.siteImprovementsAsIsCosts)
			total += (cost.siteImprovementAsIsCostAmount ?? 0);

		return total;
	}

	GetValuationMethodType() {
		if (!this.costApproachDetail)
			return undefined;
		if (!this.costApproachDetail)
			return undefined;
		return h.descriptionOrOther(this.costApproachDetail.siteValuationMethodType, this.costApproachDetail.siteValuationMethodTypeOtherDescription);
	}

	GetAnalysisType() {
		if (!this.costApproachDetail)
			return undefined;
		return h.descriptionOrOther(this.costApproachDetail.costAnalysisType, this.costApproachDetail.costAnalysisTypeOtherDescription);
	}

	GetCostMethod() {
		if (!this.costApproachDetail)
			return undefined;
		return h.descriptionOrOther(this.costApproachDetail.costMethodType, this.costApproachDetail.costMethodTypeOtherDescription);
	}

	GetDepreciationMethod() {
		if (!this.costApproachDetail)
			return undefined;
		return h.descriptionOrOther(this.costApproachDetail.depreciationMethodType, this.costApproachDetail.depreciationMethodTypeOtherDescription);
	}

	GetExclusionReasons() {
		let reasons = '';

		if (!this.valuationApproachExclusionReasons) return reasons;

		for (const reason of this.valuationApproachExclusionReasons) {
			const r = reason.GetExclusionReasonType();
			reasons = h.addWithNewline(reasons, r);
		}

		return reasons;
	}

}

